import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import Footer from '../Footer';
import { FAQ } from '../FAQ/faqs';



function AssetManagement() {
  return (
    <>
<Features docname="Asset Management"/>
<Advantages docname="Asset Management"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default AssetManagement;
